<!-- Simulatiefeedback -->
<div class="dl-feedbackbalk__item">
    @if (toontSim()) {
        <div class="dl-feedbackbalk__knop"
             [class.dl-feedbackbalk__knop--beschikbaar]="simBeschikbaar()"
             [class.dl-feedbackbalk__knop--actief]="simActief()"
             (click)="klikLampje('sim')"
             (mouseenter)="muisBinnen('sim')"
             (mouseleave)="muisBuiten()">
            <span>!</span>
            @if (simuleren()) {
                <span class="dl-feedbackbalk__telling">{{simTelling()}}</span>
            }
        </div>
        @if (simMelding(); as tekst) {
            <div class="dl-feedbackbalk__popup" [class.dl-feedbackbalk__popup--ruimtemaker]="simRuimte()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>{{tekst}}</div>
                </div>
            </div>
        }
        @if (simBallon()) {
            <div class="dl-feedbackbalk__popup"
                 [class.dl-feedbackbalk__popup--ruimtemaker]="simRuimte()"
                 (mouseenter)="popupBinnen()"
                 (mouseleave)="popupBuiten()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>
                        @for (categorie of simCategorieen(); track categorie.type) {
                            <div>
                                <p class="dl-feedbackbalk__regelkop">{{'FEEDBACK.SIM.' + categorie.type | translate}}</p>
                                @if (_debugNormmatch()) {
                                    <div class="dl-feedbackbalk__debug"><small>{{categorie.type}}</small></div>
                                }
                                @for (loop of categorie.loops; track $index) {
                                    <div class="dl-feedbackbalk__loopknop"
                                         [class.dl-feedbackbalk__loopknop--geselecteerd]="selectie().sim?.type === categorie.type && selectie().sim?.index === $index"
                                         (click)="klikSimfeedback(categorie.type, $index)">{{$index + 1}}</div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>

<!-- Normfouten -->
<div class="dl-feedbackbalk__item">
    @if (toontNorm()) {
        <div class="dl-feedbackbalk__knop"
             [class.dl-feedbackbalk__knop--beschikbaar]="normBeschikbaar()"
             [class.dl-feedbackbalk__knop--actief]="normActief()"
             (click)="klikLampje('norm')"
             (mouseenter)="muisBinnen('norm')"
             (mouseleave)="muisBuiten()">
            <span>?</span>
            @if (!simuleren()) {
                <span class="dl-feedbackbalk__telling">{{normTelling()}}</span>
            }
        </div>
        @if (normMelding(); as tekst) {
            <div class="dl-feedbackbalk__popup" [class.dl-feedbackbalk__popup--ruimtemaker]="normRuimte()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>{{tekst}}</div>
                </div>
            </div>
        }
        @if (normBallon()) {
            <div class="dl-feedbackbalk__popup"
                 [class.dl-feedbackbalk__popup--ruimtemaker]="normRuimte()"
                 (mouseenter)="popupBinnen()"
                 (mouseleave)="popupBuiten()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>
                        @for (foutregel of normRegels(); track foutregel.foutindex) {
                            <div class="dl-feedbackbalk__foutregel">
                                <span class="dl-feedbackbalk__regelkop" [innerHTML]="foutregel.tekst"></span>
                                <div>
                                    @for (knopje of foutregel.knopjes; track knopje.elementindex) {
                                        <div class="dl-feedbackbalk__loopknop"
                                             [class.dl-feedbackbalk__loopknop--geselecteerd]="geselecteerdeFout()?.foutindex === foutregel.foutindex && geselecteerdeFout()?.elementindex === knopje.elementindex"
                                             (click)="klikFout(knopje.elementId, knopje.foutcode)">{{knopje.elementindex + 1}}</div>
                                    }
                                </div>
                                @if (_debugNormmatch()) {
                                    <div class="dl-feedbackbalk__debug">
                                        <small>{{foutregel.fout}} .. {{foutregel.gebruikt}}</small>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>

<!-- Noodzakelijke bouwsuggesties -->
<div class="dl-feedbackbalk__item">
    @if (toontNoodzakelijk()) {
        <div class="dl-feedbackbalk__knop dl-feedbackbalk__knop--noodzakelijk"
             [class.dl-feedbackbalk__knop--beschikbaar]="noodzakelijkBeschikbaar()"
             [class.dl-feedbackbalk__knop--actief]="noodzakelijkActief()"
             (click)="klikLampje('noodzakelijk')"
             (mouseenter)="muisBinnen('noodzakelijk')"
             (mouseleave)="muisBuiten()">
            <span class="dl-fa4 dl-fa4--lampje"></span>
            @if (!simuleren()) {
                <span class="dl-feedbackbalk__telling">{{noodzakelijkTelling()}}</span>
            }
        </div>
        @if (noodzakelijkMelding(); as tekst) {
            <div class="dl-feedbackbalk__popup" [class.dl-feedbackbalk__popup--ruimtemaker]="noodzakelijkRuimte()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>{{tekst}}</div>
                </div>
            </div>
        }
        @if (noodzakelijkBallon()) {
            <div class="dl-feedbackbalk__popup"
                 [class.dl-feedbackbalk__popup--ruimtemaker]="noodzakelijkRuimte()"
                 (mouseenter)="popupBinnen()"
                 (mouseleave)="popupBuiten()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>
                        @for (groep of bouwsuggestieOverzicht().noodzakelijk; track groep.titel) {
                            <div class="dl-feedbackbalk__regel">
                                <span class="dl-feedbackbalk__regelkop">{{groep.titel}}</span>
                                <div>
                                    @for (instantie of groep.instanties; track instantie.id) {
                                        <div class="dl-feedbackbalk__loopknop"
                                             [class.dl-feedbackbalk__loopknop--geselecteerd]="selectie().bs?.handle === instantie.handle && selectie().bs?.nodeId === instantie.id"
                                             (click)="klikBouwsuggestie(instantie.handle, instantie.id, 'noodzakelijk')">{{$index + 1}}</div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>

<!-- Gewenste bouwsuggesties -->
<div class="dl-feedbackbalk__item">
    @if (toontGewenst()) {
        <div class="dl-feedbackbalk__knop dl-feedbackbalk__knop--gewenst"
             [class.dl-feedbackbalk__knop--beschikbaar]="gewenstBeschikbaar()"
             [class.dl-feedbackbalk__knop--actief]="gewenstActief()"
             (click)="klikLampje('gewenst')"
             (mouseenter)="muisBinnen('gewenst')"
             (mouseleave)="muisBuiten()">
            <span class="dl-fa4 dl-fa4--lampje"></span>
            @if (!simuleren()) {
                <span class="dl-feedbackbalk__telling">{{gewenstTelling()}}</span>
            }
        </div>
        @if (gewenstMelding(); as tekst) {
            <div class="dl-feedbackbalk__popup" [class.dl-feedbackbalk__popup--ruimtemaker]="gewenstRuimte()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>{{tekst}}</div>
                </div>
            </div>
        }
        @if (gewenstBallon()) {
            <div class="dl-feedbackbalk__popup"
                 [class.dl-feedbackbalk__popup--ruimtemaker]="gewenstRuimte()"
                 (mouseenter)="popupBinnen()"
                 (mouseleave)="popupBuiten()">
                <div class="dl-feedbackbalk__ballon">
                    <div class="dl-feedbackbalk__tekst" dlMaxHoogteCanvas>
                        @for (groep of bouwsuggestieOverzicht().gewenst; track groep.titel) {
                            <div class="dl-feedbackbalk__regel">
                                <span class="dl-feedbackbalk__regelkop">{{groep.titel}}</span>
                                <div>
                                    @for (instantie of groep.instanties; track instantie.id) {
                                        <div class="dl-feedbackbalk__loopknop"
                                             [class.dl-feedbackbalk__loopknop--geselecteerd]="selectie().bs?.handle === instantie.handle && selectie().bs?.nodeId === instantie.id"
                                             (click)="klikBouwsuggestie(instantie.handle, instantie.id, 'gewenst')">{{$index + 1}}</div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    }
</div>

<!-- Tekstbeschrijving -->
<div class="dl-feedbackbalk__item">
    @if (toontTekstbeschrijving()) {
        <div class="dl-feedbackbalk__knop dl-feedbackbalk__knop--beschikbaar dl-feedbackbalk__knop--tekstbeschrijving"
             [class.dl-feedbackbalk__knop--actief]="weergaveInstellingen.tekstbeschrijvingAan()"
             role="button"
             [attr.aria-pressed]="weergaveInstellingen.tekstbeschrijvingAan()"
             [title]="(weergaveInstellingen.tekstbeschrijvingAan() ? 'TEKSTBESCHRIJVING.UITSCHAKELEN' : 'TEKSTBESCHRIJVING.INSCHAKELEN') | translate"
             (click)="klikTekstbeschrijving()">
            <span class="fa-regular fa-file-lines" aria-hidden="true"></span>
        </div>
    }
</div>
